import { render, staticRenderFns } from "./taskPlanIndex.vue?vue&type=template&id=1534720c&scoped=true"
import script from "./taskPlanIndex.vue?vue&type=script&lang=js"
export * from "./taskPlanIndex.vue?vue&type=script&lang=js"
import style0 from "./taskPlanIndex.vue?vue&type=style&index=0&id=1534720c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1534720c",
  null
  
)

export default component.exports